var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"d-flex pa-0"},[_c('v-icon',{staticClass:"mr-2",attrs:{"size":"24","color":"blue-grey darken-1"}},[_vm._v("mdi-history")]),_c('div',[_c('p',{staticClass:"mb-0 caption blue-grey--text text--darken-2"},[_c('router-link',{staticClass:"cursor-pointer caption text-decoration-none",attrs:{"to":{
          name: 'profile',
          params: {
            organizationId: _vm.logItem.targetOrganizationId,
            userId: _vm.logItem.sourceAccountId,
          },
        }}},[_vm._v("\n        "+_vm._s(_vm.logItem.sourceAccountName)+"\n      ")]),_vm._v("\n\n      "+_vm._s(_vm.message)+"\n    ")],1),_c('p',{staticClass:"mb-0 caption blue-grey--text text--darken-1"},[_vm._v("\n      "+_vm._s(_vm.logDate)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }